// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This style file is imported by Dropbox.js which is called by home component.
*/

.dropdown-container {
  display: flex;
  align-items: center;
  gap: 2%;
  margin-bottom: 3%;
  justify-content: flex-start;
  width:100%;
  flex-wrap: wrap;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 1%;
  flex: 0 0 23%;       
  min-width: 12%;
}

.dropdown-item label {
  color: #0C3135;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  white-space: nowrap;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 2%;              /*search bar field */
  flex: 1 1 30%;
  min-width: 15%;
}

select, input[type="text"] {
  padding: 1%;
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 100%;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
}

select {
  width: 100%;
}

/* New namespace dropdown styles */
.namespace-dropdown {
  position: relative;
  width: 100%;
}

.namespace-select-header {
  padding: 1%;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: white;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
}

.namespace-select-header.disabled {
  background-color: #f0f0f0;
  cursor: not-allowed;
  color: #666;
}

.namespace-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  margin-top: 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.namespace-option {
  padding: 1%;
}

.namespace-option:hover {
  background-color: #f5f5f5;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  padding: 1%;
}

.checkbox-label input[type="checkbox"] {
  margin: 0;
}

.checkbox-text {
  color: #0C3135;
}

.filter-condition {
  margin: 10px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-condition select {
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.namespace-select-header {
  position: relative;
}

.tooltip-content {
  position: absolute;
  bottom: 100%; /* Changed from top: 100% to bottom: 100% */
  left: 0;
  background-color: #333;
  color: white;
  padding: 8px;
  border-radius: 4px;
  z-index: 1000;
  max-width: max-content; 
  min-width: min-content; 
  margin-bottom: 5px; 
}

.tooltip-content::before {
  content: '';
  position: absolute;
  top: 100%; 
  left: 10px;
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent; 
}
.filter-condition select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.aws-account-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  min-width: 200px;
}

.aws-account-container label {
  white-space: nowrap;
  color: #0C3135;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
}

.aws-account-container select {
  flex: 1 1;
  padding: 1%;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  min-width: 60%;
  gap:0.5rem;
  width: 100%;
}

.search-container {
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.dropdown-search {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.dropdown-search:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.2);
}


@media (max-width: 321px) {
  .dropdown-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px;
    gap: 20px;
  }

  /* Force each container to take full width and stack */
  .aws-account-container,
  .dropdown-item,
  .search-bar {
    width: 100%;
    min-width: 100%;
    flex: 0 0 100%;
    margin: 0;
    display: flex;
    flex-direction: column;
  }

  /* Ensure labels and inputs stack properly */
  .aws-account-container label,
  .dropdown-item label {
    display: block;
    width: 100%;
    margin-bottom: 0;
  }

  /* Make all selects and inputs full width */
  select,
  input[type="text"],
  .namespace-select-header {
    width: 100%;
    min-width: 100%;
    margin-top: 5px;
  }

  /* Remove any residual floating or positioning */
  .namespace-dropdown {
    width: 100%;
    position: relative;
  }

  /* Reset any margins that might cause unwanted spacing */
  .dropdown-item + .dropdown-item,
  .search-bar {
    margin-top: 0;
  }

  /* Ensure proper spacing between grouped elements */
  .namespace-select-header + .namespace-options {
    margin-top: 5px;
  }
}

/* Base styles update to help with mobile transition */
.dropdown-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
}

.dropdown-item,
.aws-account-container,
.search-bar {
  display: flex;
  align-items: center;
}



@media (min-width: 321px) and (max-width: 376px)  {
  .dropdown-container {
    display: flex;
    flex-direction: column;
    width: 95%;
    padding: 10px;
    gap: 20px;
    margin-left: 3%;
  }

  /* Force each container to take full width and stack */
  .aws-account-container,
  .dropdown-item,
  .search-bar {
    width: 100%;
    min-width: 100%;
    flex: 0 0 100%;
    margin: 0;
    display: flex;
    flex-direction: column;
    
  }

  /* Ensure labels and inputs stack properly */
  .aws-account-container label,
  .dropdown-item label {
    display: block;
    width: 100%;
    margin-bottom: 0;
  }

  /* Make all selects and inputs full width */
  select,
  input[type="text"],
  .namespace-select-header {
    width: 100%;
    min-width: 100%;
    margin-top: 5px;
  }

  /* Remove any residual floating or positioning */
  .namespace-dropdown {
    width: 100%;
    position: relative;
  }

  /* Reset any margins that might cause unwanted spacing */
  .dropdown-item + .dropdown-item,
  .search-bar {
    margin-top: 0;
  }

  /* Ensure proper spacing between grouped elements */
  .namespace-select-header + .namespace-options {
    margin-top: 5px;
  }
}

@media  (min-width: 376px) and (max-width: 426px)  {
  .dropdown-container {
    display: flex;
    flex-direction: column;
    width: 95%;
    padding: 10px;
    gap: 20px;
    margin-left: 3%;
  }

  /* Force each container to take full width and stack */
  .aws-account-container,
  .dropdown-item,
  .search-bar {
    width: 100%;
    min-width: 100%;
    flex: 0 0 100%;
    margin: 0;
    display: flex;
    flex-direction: column;
    
  }

  /* Ensure labels and inputs stack properly */
  .aws-account-container label,
  .dropdown-item label {
    display: block;
    width: 100%;
    margin-bottom: 0;
  }

  /* Make all selects and inputs full width */
  select,
  input[type="text"],
  .namespace-select-header {
    width: 100%;
    min-width: 100%;
    margin-top: 5px;
  }

  /* Remove any residual floating or positioning */
  .namespace-dropdown {
    width: 100%;
    position: relative;
  }

  /* Reset any margins that might cause unwanted spacing */
  .dropdown-item + .dropdown-item,
  .search-bar {
    margin-top: 0;
  }

  /* Ensure proper spacing between grouped elements */
  .namespace-select-header + .namespace-options {
    margin-top: 5px;
  }
}

@media (min-width: 426px) and (max-width: 769px) {
  .dropdown-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 16px;
    padding: 16px;
    width: 95%;
  }

  /* AWS Account styling */
  .aws-account-container {
    grid-column: 1;
    grid-row: 1;
  }

  /* Cluster styling */
  .cluster-container {
    grid-column: 2;
    grid-row: 1;
    align-self: flex-start;
  }

  /* Namespace styling */
  .namespace-container {
    grid-column: 2;
    grid-row: 2;
    align-self: flex-start;
  }

  /* Search styling */
  .search-container {
    grid-column: 2;
    grid-row: 3;
  }

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 0.9rem;
    color: #333;
  }

  select, input[type="text"] {
    width: 100%;
    padding: 6px 7px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.9rem;
  }

  .aws-account-container select {
    width: 100%;
  }

  .cluster-container select {
    width: 100%;
  }

  .namespace-container select {
    width: 100%;
  }

  .search-container input {
    width: 80%;
  }

  /* Add vertical spacing between stacked elements */
  .cluster-container,
  .namespace-container,
  .search-container {
    margin-bottom: 12px;
  }
}

@media (min-width: 769px) and (max-width: 1025px) {
  .dropdown-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 3.8%;
    width: 100%;
    padding: 5px;
  }

  .aws-account-container {
    flex: 0 0 20%;
    gap:0%;
  }

  .dropdown-item {
    flex: 0 0 25%;
  }

  .search-bar {
    flex: 0 0 15%;
    margin-left: auto;  /* This line pushes the search bar to the right */
  }

  select,
  input[type="text"],
  .namespace-select-header {
    width: 100%;
    min-width: 0;
    font-size: 0.8rem;
  }

  .dropdown-item label,
  .aws-account-container label {
    font-size: 1.0rem;
    margin-right: 4px;
  }
}

@media (min-width: 1025px) and (max-width: 1441px) {
  .dropdown-container{
    gap:2.0%;
  }

  .search-bar {
    flex: 0 0 25%;
    margin-left: auto;  /* This line pushes the search bar to the right */
  }
}

@media (min-width: 1441px) and (max-width: 1921px) {
  .dropdown-container{
    gap:3.0%;
  }

  .search-bar {
    flex: 0 0 20%;
    margin-left: auto;  /* This line pushes the search bar to the right */
  }
}

@media (min-width: 1921px){
  .dropdown-container{
    gap:3%;
  }

  .search-bar {
    flex: 0 0 15%;
    margin-left: auto;  /* This line pushes the search bar to the right */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ServiceInventoryDashboard/Dropbox.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,iBAAiB;EACjB,2BAA2B;EAC3B,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO,eAAe,oBAAoB;EAC1C,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,2CAA2C;EACzD,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;;AAGA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,SAAS;EACX;;EAEA,sDAAsD;EACtD;;;IAGE,WAAW;IACX,eAAe;IACf,cAAc;IACd,SAAS;IACT,aAAa;IACb,sBAAsB;EACxB;;EAEA,4CAA4C;EAC5C;;IAEE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;;;IAGE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA,gDAAgD;EAChD;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA,wDAAwD;EACxD;;IAEE,aAAa;EACf;;EAEA,mDAAmD;EACnD;IACE,eAAe;EACjB;AACF;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;;;AAIA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA,sDAAsD;EACtD;;;IAGE,WAAW;IACX,eAAe;IACf,cAAc;IACd,SAAS;IACT,aAAa;IACb,sBAAsB;;EAExB;;EAEA,4CAA4C;EAC5C;;IAEE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;;;IAGE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA,gDAAgD;EAChD;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA,wDAAwD;EACxD;;IAEE,aAAa;EACf;;EAEA,mDAAmD;EACnD;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA,sDAAsD;EACtD;;;IAGE,WAAW;IACX,eAAe;IACf,cAAc;IACd,SAAS;IACT,aAAa;IACb,sBAAsB;;EAExB;;EAEA,4CAA4C;EAC5C;;IAEE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;;;IAGE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA,gDAAgD;EAChD;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA,wDAAwD;EACxD;;IAEE,aAAa;EACf;;EAEA,mDAAmD;EACnD;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,aAAa;IACb,UAAU;EACZ;;EAEA,wBAAwB;EACxB;IACE,cAAc;IACd,WAAW;EACb;;EAEA,oBAAoB;EACpB;IACE,cAAc;IACd,WAAW;IACX,sBAAsB;EACxB;;EAEA,sBAAsB;EACtB;IACE,cAAc;IACd,WAAW;IACX,sBAAsB;EACxB;;EAEA,mBAAmB;EACnB;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA,kDAAkD;EAClD;;;IAGE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,MAAM;EACR;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,iBAAiB,GAAG,iDAAiD;EACvE;;EAEA;;;IAGE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,iBAAiB,GAAG,iDAAiD;EACvE;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,iBAAiB,GAAG,iDAAiD;EACvE;AACF;;AAEA;EACE;IACE,MAAM;EACR;;EAEA;IACE,aAAa;IACb,iBAAiB,GAAG,iDAAiD;EACvE;AACF","sourcesContent":["/*\nThis style file is imported by Dropbox.js which is called by home component.\n*/\n\n.dropdown-container {\n  display: flex;\n  align-items: center;\n  gap: 2%;\n  margin-bottom: 3%;\n  justify-content: flex-start;\n  width:100%;\n  flex-wrap: wrap;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 1%;\n  flex: 0 0 23%;       \n  min-width: 12%;\n}\n\n.dropdown-item label {\n  color: #0C3135;\n  font-family: 'Poppins', sans-serif;\n  font-size: 1rem;\n  white-space: nowrap;\n}\n\n.search-bar {\n  display: flex;\n  align-items: center;\n  gap: 2%;              /*search bar field */\n  flex: 1 1 30%;\n  min-width: 15%;\n}\n\nselect, input[type=\"text\"] {\n  padding: 1%;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: 'Poppins', sans-serif;\n  font-size: 1rem;\n}\n\nselect {\n  width: 100%;\n}\n\n/* New namespace dropdown styles */\n.namespace-dropdown {\n  position: relative;\n  width: 100%;\n}\n\n.namespace-select-header {\n  padding: 1%;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background-color: white;\n  cursor: pointer;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: 'Poppins', sans-serif;\n  font-size: 1rem;\n}\n\n.namespace-select-header.disabled {\n  background-color: #f0f0f0;\n  cursor: not-allowed;\n  color: #666;\n}\n\n.namespace-options {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 1000;\n  margin-top: 2px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.namespace-option {\n  padding: 1%;\n}\n\n.namespace-option:hover {\n  background-color: #f5f5f5;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  font-family: 'Poppins', sans-serif;\n  font-size: 1rem;\n  padding: 1%;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  margin: 0;\n}\n\n.checkbox-text {\n  color: #0C3135;\n}\n\n.filter-condition {\n  margin: 10px 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filter-condition select {\n  padding: 5px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.namespace-select-header {\n  position: relative;\n}\n\n.tooltip-content {\n  position: absolute;\n  bottom: 100%; /* Changed from top: 100% to bottom: 100% */\n  left: 0;\n  background-color: #333;\n  color: white;\n  padding: 8px;\n  border-radius: 4px;\n  z-index: 1000;\n  max-width: max-content; \n  min-width: min-content; \n  margin-bottom: 5px; \n}\n\n.tooltip-content::before {\n  content: '';\n  position: absolute;\n  top: 100%; \n  left: 10px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #333 transparent transparent transparent; \n}\n.filter-condition select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.aws-account-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 0 0 auto;\n  min-width: 200px;\n}\n\n.aws-account-container label {\n  white-space: nowrap;\n  color: #0C3135;\n  font-family: 'Poppins', sans-serif;\n  font-size: 1rem;\n}\n\n.aws-account-container select {\n  flex: 1;\n  padding: 1%;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 1rem;\n  min-width: 60%;\n  gap:0.5rem;\n  width: 100%;\n}\n\n.search-container {\n  padding: 8px;\n  border-bottom: 1px solid #eee;\n}\n\n.dropdown-search {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.dropdown-search:focus {\n  outline: none;\n  border-color: #0066cc;\n  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.2);\n}\n\n\n@media (max-width: 321px) {\n  .dropdown-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 10px;\n    gap: 20px;\n  }\n\n  /* Force each container to take full width and stack */\n  .aws-account-container,\n  .dropdown-item,\n  .search-bar {\n    width: 100%;\n    min-width: 100%;\n    flex: 0 0 100%;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n  }\n\n  /* Ensure labels and inputs stack properly */\n  .aws-account-container label,\n  .dropdown-item label {\n    display: block;\n    width: 100%;\n    margin-bottom: 0;\n  }\n\n  /* Make all selects and inputs full width */\n  select,\n  input[type=\"text\"],\n  .namespace-select-header {\n    width: 100%;\n    min-width: 100%;\n    margin-top: 5px;\n  }\n\n  /* Remove any residual floating or positioning */\n  .namespace-dropdown {\n    width: 100%;\n    position: relative;\n  }\n\n  /* Reset any margins that might cause unwanted spacing */\n  .dropdown-item + .dropdown-item,\n  .search-bar {\n    margin-top: 0;\n  }\n\n  /* Ensure proper spacing between grouped elements */\n  .namespace-select-header + .namespace-options {\n    margin-top: 5px;\n  }\n}\n\n/* Base styles update to help with mobile transition */\n.dropdown-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  width: 100%;\n}\n\n.dropdown-item,\n.aws-account-container,\n.search-bar {\n  display: flex;\n  align-items: center;\n}\n\n\n\n@media (min-width: 321px) and (max-width: 376px)  {\n  .dropdown-container {\n    display: flex;\n    flex-direction: column;\n    width: 95%;\n    padding: 10px;\n    gap: 20px;\n    margin-left: 3%;\n  }\n\n  /* Force each container to take full width and stack */\n  .aws-account-container,\n  .dropdown-item,\n  .search-bar {\n    width: 100%;\n    min-width: 100%;\n    flex: 0 0 100%;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    \n  }\n\n  /* Ensure labels and inputs stack properly */\n  .aws-account-container label,\n  .dropdown-item label {\n    display: block;\n    width: 100%;\n    margin-bottom: 0;\n  }\n\n  /* Make all selects and inputs full width */\n  select,\n  input[type=\"text\"],\n  .namespace-select-header {\n    width: 100%;\n    min-width: 100%;\n    margin-top: 5px;\n  }\n\n  /* Remove any residual floating or positioning */\n  .namespace-dropdown {\n    width: 100%;\n    position: relative;\n  }\n\n  /* Reset any margins that might cause unwanted spacing */\n  .dropdown-item + .dropdown-item,\n  .search-bar {\n    margin-top: 0;\n  }\n\n  /* Ensure proper spacing between grouped elements */\n  .namespace-select-header + .namespace-options {\n    margin-top: 5px;\n  }\n}\n\n@media  (min-width: 376px) and (max-width: 426px)  {\n  .dropdown-container {\n    display: flex;\n    flex-direction: column;\n    width: 95%;\n    padding: 10px;\n    gap: 20px;\n    margin-left: 3%;\n  }\n\n  /* Force each container to take full width and stack */\n  .aws-account-container,\n  .dropdown-item,\n  .search-bar {\n    width: 100%;\n    min-width: 100%;\n    flex: 0 0 100%;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    \n  }\n\n  /* Ensure labels and inputs stack properly */\n  .aws-account-container label,\n  .dropdown-item label {\n    display: block;\n    width: 100%;\n    margin-bottom: 0;\n  }\n\n  /* Make all selects and inputs full width */\n  select,\n  input[type=\"text\"],\n  .namespace-select-header {\n    width: 100%;\n    min-width: 100%;\n    margin-top: 5px;\n  }\n\n  /* Remove any residual floating or positioning */\n  .namespace-dropdown {\n    width: 100%;\n    position: relative;\n  }\n\n  /* Reset any margins that might cause unwanted spacing */\n  .dropdown-item + .dropdown-item,\n  .search-bar {\n    margin-top: 0;\n  }\n\n  /* Ensure proper spacing between grouped elements */\n  .namespace-select-header + .namespace-options {\n    margin-top: 5px;\n  }\n}\n\n@media (min-width: 426px) and (max-width: 769px) {\n  .dropdown-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 16px;\n    padding: 16px;\n    width: 95%;\n  }\n\n  /* AWS Account styling */\n  .aws-account-container {\n    grid-column: 1;\n    grid-row: 1;\n  }\n\n  /* Cluster styling */\n  .cluster-container {\n    grid-column: 2;\n    grid-row: 1;\n    align-self: flex-start;\n  }\n\n  /* Namespace styling */\n  .namespace-container {\n    grid-column: 2;\n    grid-row: 2;\n    align-self: flex-start;\n  }\n\n  /* Search styling */\n  .search-container {\n    grid-column: 2;\n    grid-row: 3;\n  }\n\n  label {\n    display: block;\n    margin-bottom: 8px;\n    font-size: 0.9rem;\n    color: #333;\n  }\n\n  select, input[type=\"text\"] {\n    width: 100%;\n    padding: 6px 7px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 0.9rem;\n  }\n\n  .aws-account-container select {\n    width: 100%;\n  }\n\n  .cluster-container select {\n    width: 100%;\n  }\n\n  .namespace-container select {\n    width: 100%;\n  }\n\n  .search-container input {\n    width: 80%;\n  }\n\n  /* Add vertical spacing between stacked elements */\n  .cluster-container,\n  .namespace-container,\n  .search-container {\n    margin-bottom: 12px;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1025px) {\n  .dropdown-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 3.8%;\n    width: 100%;\n    padding: 5px;\n  }\n\n  .aws-account-container {\n    flex: 0 0 20%;\n    gap:0%;\n  }\n\n  .dropdown-item {\n    flex: 0 0 25%;\n  }\n\n  .search-bar {\n    flex: 0 0 15%;\n    margin-left: auto;  /* This line pushes the search bar to the right */\n  }\n\n  select,\n  input[type=\"text\"],\n  .namespace-select-header {\n    width: 100%;\n    min-width: 0;\n    font-size: 0.8rem;\n  }\n\n  .dropdown-item label,\n  .aws-account-container label {\n    font-size: 1.0rem;\n    margin-right: 4px;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1441px) {\n  .dropdown-container{\n    gap:2.0%;\n  }\n\n  .search-bar {\n    flex: 0 0 25%;\n    margin-left: auto;  /* This line pushes the search bar to the right */\n  }\n}\n\n@media (min-width: 1441px) and (max-width: 1921px) {\n  .dropdown-container{\n    gap:3.0%;\n  }\n\n  .search-bar {\n    flex: 0 0 20%;\n    margin-left: auto;  /* This line pushes the search bar to the right */\n  }\n}\n\n@media (min-width: 1921px){\n  .dropdown-container{\n    gap:3%;\n  }\n\n  .search-bar {\n    flex: 0 0 15%;\n    margin-left: auto;  /* This line pushes the search bar to the right */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
